import useFileHook from "hooks/useFileHook";
import CommentField from "components/common/CommentFIeld/CommentField";
import useActivityFieldActions from "pages/common/ShipmentTrackingV2/hooks/useActivityFieldActions";

const MAX_FILE_COUNT = 10;
interface ActivityFieldProps {
  shipmentId: string;
}

export default function ActivityField({ shipmentId }: ActivityFieldProps) {
  const {
    files,
    filesSortedByErrorsFirst,
    resetFiles,
    handlePaste,
    dragging,
    draggableProps,
    handleRemoveFile,
    handleFileUpload,
    hiddenFileInputRef,
  } = useFileHook({ maxFileCount: MAX_FILE_COUNT });

  const { textAreaRef, isSubmitting, handleSubmitTrackingUpdate } = useActivityFieldActions({
    shipmentId,
    files,
    resetFiles,
  });

  return (
    <CommentField
      dragging={dragging}
      draggableProps={draggableProps}
      textAreaRef={textAreaRef}
      onPaste={handlePaste}
      files={files}
      filesSortedByErrorsFirst={filesSortedByErrorsFirst}
      onFileRemove={handleRemoveFile}
      maxFileCount={MAX_FILE_COUNT}
      hiddenFileInputRef={hiddenFileInputRef}
      onFileUpload={handleFileUpload}
      onSubmit={handleSubmitTrackingUpdate}
      isSubmitting={isSubmitting}
    />
  );
}
